import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text, VStack } from '@library';
import type { NewsFilters } from '../../../hooks/useNewsArchive';
import CategoryFilter from './CategoryFilter';

const PostsFilters = ({
    filters,
    changeFilters,
}: {
    filters: NewsFilters;
    changeFilters: (val: NewsFilters) => void;
}) => {
    return (
        <VStack gap="medium">
            <VStack gap="small">
                <Text primary bold>
                    <FormattedMessage id="category" />
                </Text>
                <CategoryFilter
                    values={filters.categories}
                    onChange={values => {
                        changeFilters({ ...filters, categories: values });
                    }}
                />
            </VStack>
        </VStack>
    );
};

export default memo(PostsFilters);
